var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article_to_show.condition_id)?_c('p',{staticClass:"condicion-articulo"},[_vm._v(" "+_vm._s(_vm.article_to_show.condition.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }